@if (incidentType && customFieldsForm) {
    <div class="custom-fields-tab">
        @if (incidentType.customFields && incidentType.customFields.length > 0) {
            <incident-custom-fields-section
                [sectionName]="'Details'"
                [customFields]="incidentType.customFields"
                [customFieldsForm]="customFieldsForm.controls[incidentType.id]"
                [currentSelectedOrganizations]="currentSelectedOrganizations"
                [currentSelectedThirdParties]="currentSelectedThirdParties"
                [currencies]="currencies"
                [isFlat]="flatSection"
            >
            </incident-custom-fields-section>
        }
        @if (incidentType.incidentTypeSections) {
            @for (its of incidentType.incidentTypeSections; track $index) {
                @if (its.customFields && its.customFields.length > 0) {
                    <incident-custom-fields-section
                        [sectionName]="its.name"
                        [customFields]="its.customFields"
                        [customFieldsForm]="customFieldsForm.controls[its.id]"
                        [currentSelectedOrganizations]="currentSelectedOrganizations"
                        [currentSelectedThirdParties]="currentSelectedThirdParties"
                        [currencies]="currencies"
                    >
                    </incident-custom-fields-section>
                }
            }
        }
    </div>
}
